<template>
	<div class="bodily">
		<!-- <h3 class="qjc-fts-16 qjc-c-dark qjc-ftw-500">產婦信息</h3> -->
		<div class="insert-title">媽媽信息</div>
		
		<h4 class="qjc-fts-14 qjc-c-dark qjc-ftw-500">產前兩年內是患過下列疾病？(多選)</h4>
		<el-radio v-model="hasPredis2" label="0" class="qjc-wid-100">無</el-radio>
		<el-radio v-model="hasPredis2" label="1" class="qjc-wid-100">有，請選擇（多選）</el-radio>
		
		<el-checkbox-group
			v-model="formData.predis2"
			:disabled="hasPredis2==0?true:false"
		>
			<el-checkbox v-for="item in list" :key="item.val" :label="item.val" :title="item.name">{{ item.name }}</el-checkbox>
		</el-checkbox-group>
		
		<div class="footer-btn">
			<el-button @click="handlePrev" class="prev qjc-fts-16 qjc-block">上一步</el-button>
			<el-button @click="next" class="next qjc-fts-16 qjc-block">下一步</el-button>
		</div>
		
	</div>
</template>

<script>
	export default{
		name: 'puerperaComplex',
		data() {
			return {
				list: [
					{ val: 'DIS01', name: '卵巢功能障礙' },
					{ val: 'DIS02', name: '感冒>=3次' },
					{ val: 'DIS03', name: '頭頸疾病' },
					{ val: 'DIS04', name: '營養缺乏' },
					{ val: 'DIS05', name: '高血壓疾病' },
					{ val: 'DIS06', name: '慢性肝病' },
					{ val: 'DIS07', name: '消化道疾病<3次' },
					{ val: 'DIS08', name: '流產' },
					{ val: 'DIS09', name: '腦血管疾病' },
					{ val: 'DIS10', name: '女性生殖器官腫瘤' },
					{ val: 'DIS11', name: '關節疾患' },
					{ val: 'DIS12', name: '糖尿病' },
					{ val: 'DIS13', name: '慢性阻塞性肺部疾病(COPD)' },
					{ val: 'DIS14', name: '泌尿系統疾患(除腎臟外)' },
					{ val: 'DIS15', name: '腎臟疾病' },
					{ val: 'DIS16', name: '子宮、卵巢相關癌症' },
					{ val: 'DIS17', name: '妊娠疾病' },
					{ val: 'DIS18', name: '癲癇' },
					{ val: 'DIS19', name: '精神疾病+憂鬱症' },
					{ val: 'DIS20', name: '甲狀腺疾患' },
					{ val: 'DIS21', name: '眼部疾患' },
					{ val: 'DIS22', name: '感冒<3次' },
					{ val: 'DIS23', name: '貧血' },
					{ val: 'DIS24', name: '肥胖及營養過度' },
					{ val: 'DIS25', name: '皮膚疾病' },
					{ val: 'DIS26', name: '惡性腫瘤' },
					{ val: 'DIS27', name: '心臟病' },
					{ val: 'DIS28', name: '消化道疾病>=3次' },
					{ val: 'DIS29', name: '女性生理期疾患' },
					{ val: 'DIS30', name: '頭痛' },
					{ val: 'DIS31', name: '痔瘡' },
					{ val: 'DIS32', name: '口腔疾患>=3次' },
					{ val: 'DIS33', name: '痛風' },
					{ val: 'DIS34', name: '良性腫瘤' },
					{ val: 'DIS35', name: '乳癌' },
					{ val: 'DIS36', name: '腹部骨盆疾病' },
					{ val: 'DIS37', name: '乳房疾患' },
					{ val: 'DIS38', name: '黴菌病' },
					{ val: 'DIS39', name: '口腔疾患<3次' },
					{ val: 'DIS41', name: '肺炎' }
				],
			
				hasPredis2: '0'// 是否患病
				
			}
		},
		props: ['formData'],
		created() {
			this.hasPredis2 = (this.formData.predis2 && this.formData.predis2.length>0)?'1':'0'// 是否患病
		},
		watch: {
			hasPredis2(val) {// 選擇無疾病時清空已選項
				if(val == '0'){
					this.formData.predis2 = [];
				}
			}
		},
		methods: {
			next() {
				if(this.hasPredis2 == '0' && this.formData.predis2.length > 0){
					this.$myAlert({
						type: 'fail',
						title: '選擇錯誤'
					});
				}else if(this.hasPredis2 == '1' && this.formData.predis2.length == 0){
					this.$myAlert({
						type: 'fail',
						title: '選擇錯誤',
						content: '請選擇至少一種疾病或無患病'
					});
				}else{
					this.$emit('checkTab', 'Newborn');
				}
			},
			handlePrev() {
				this.$emit('checkTab', 'myBodily');
			},
		}
	}
</script>

<style scoped>
	.el-radio >>> .el-radio__label,
	.el-checkbox >>> .el-checkbox__label{
		font-size: 14px;
		line-height: 14px;
		color: #777F8F;
	}
	.el-checkbox >>> .el-checkbox__label{
		padding-left: 6px;
	}
	.el-form >>> .el-radio.is-bordered.is-checked {
		border-color: #6681FA
	}
</style>
<style lang="scss" scoped>
	.bodily{
		padding-top: 32px;
		
		.insert-title {
			position: relative;
			font-size: 16px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #293033;
			line-height: 16px;
			padding-bottom: 15px;
			border-bottom: 1px solid #E5E8F5;
			margin-bottom: 32px;
			
			&::before{
				position: absolute;
				left: -24px;
				top: 0;
				content: '';
				width: 4px;
				height: 20px;
				background-color: #6883FB;
			}
		}	
		
		&>h4{
			margin: 24px 0 16px;
		}
		
		.el-radio{
			margin-bottom: 16px;
			margin-right: 20px;
		}
		
		.el-checkbox-group{
			background-color: #F2F4FD;
			border: 1px solid #E5E9F9;
			border-radius: 4px;
			
			.el-checkbox{
				width: 16.666%;
				line-height: 14px;
				margin-right: 0;
				padding: 11px 16px;
				border-bottom: 1px solid #fff;
				overflow: hidden;
				
				&:not(:nth-child(6n)){
					border-right: 1px solid #fff;
				}
			}
		}
		
		.footer-btn {
			display: flex;
			justify-content: center;
			align-items: center;
			margin-top: 40px;
		}
				
		.next{
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: none;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #fff;
		}
		.prev {
			width: 96px;
			height: 34px;
			border-radius: 17px;
			border: 1px solid #6883FB;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #6883FB;
			background-color: #fff;
			margin-right: 24px;
		}
	}
</style>
